import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '物料价格信息',
    type: 2,
    labelClass: 'yellow',
    labelName: '工',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'details',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: [
          {
            componentType: 'el-select',
            componentName: '输入框',
            fieldKey: 'supplierId',
            fieldName: '供应商',
            placeholder: '',
            value: '',
            option: [],
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: 'supplier/page',
              filterable: true,
              selectType: 2, // 1本地2远程
              remote: true
            }
          },
          {
            componentType: 'el-select',
            componentName: '输入框',
            fieldKey: 'materialId',
            fieldName: '材料',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            option: [],
            config: {
              collapseTags: true,
              isDisabled: false,
              multiple: false,
              clearable: true,
              url: 'material/page',
              pickerType: '',
              filterable: true,
              selectType: 2, // 1本地2远程
              remote: true,
              isHide: true
            }
          },
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'fee',
            fieldName: '费用',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-select',
            componentName: '下拉选择',
            fieldKey: 'containsRate',
            fieldName: '是否含税',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            option: [{
              id: false,
              name: '否'
            }, {
              id: true,
              name: '是'
            }],
            config: {
              collapseTags: true,
              isDisabled: false,
              multiple: false,
              clearable: true,
              url: '',
              pickerType: '',
              filterable: true,
              selectType: 3// 1本地2远程
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'rate',
            fieldName: '税率',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-select',
            componentName: '输入框',
            fieldKey: 'invoiceType',
            fieldName: '发票类型',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            option: [],
            config: {
              collapseTags: true,
              isDisabled: false,
              multiple: false,
              clearable: true,
              url: 'dropdown/InvoiceType',
              pickerType: '',
              filterable: true,
              label: 'mark',
              selectType: 2 // 1本地2远程
            }
          }
        ]
      }
    ]
  }
]
